import AuthService from '@/features/auth/authService.js'

const CHAT_CONFIG = {
  serviceId: '6962843faf54bb42894fd902',
  projectId: '69628892af54bb42894fd904',
  adminUserId: 'admin-1',
}

let initialized = false
let initPromise = null

/**
 * Vérifie si de nouveaux messages peuvent être envoyés pour une conversation
 * @param {Object} conversation
 * @returns {Promise<boolean>}
 */
async function checkCanAddNewMessage(conversation) {
  try {
    const meta = conversation?.metadata || {}
    const type = meta.type || meta.orderType

    // Si ce n'est ni une commande ni un colis (ex: support admin), pas de blocage
    if (type !== 'order' && type !== 'package') {
      return true
    }

    const id = type === 'order' ? (meta.orderId || meta.id) : (meta.packageId || meta.id)
    if (!id) {
      return true
    }

    const endpoint = type === 'order'
      ? `https://api.monrapidoo.com/order/details/${id}?group=ultraxeno`
      : `https://api.monrapidoo.com/package/details/${id}?group=ultraxeno`

    const res = await fetch(endpoint, {
      method: 'GET'
    })

    if (!res.ok) {
      return false
    }

    const json = await res.json()
    const status = json?.data?.status

    // Si livré, pas d'envoi de nouveaux messages autorisé
    if (status === 'delivered') {
      return false
    }

    return true
  } catch (error) {
    console.error('Erreur lors de la vérification du statut commande/colis pour livreur:', error)
    return false
  }
}

function initChatWidget() {
  // Déjà en cours d'initialisation
  if (initPromise) return initPromise

  // Déjà initialisé
  if (initialized) return Promise.resolve()

  initPromise = new Promise((resolve, reject) => {
    const tryInit = () => {
      const user = AuthService.getUserData()

      if (!user) {
        initPromise = null
        resolve()
        return
      }

      if (!window.XenoTalk) {
        setTimeout(tryInit, 100)
        return
      }

      try {
        const riderName = user
          ? `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.name || user.email || 'Livreur'
          : 'Livreur'

        window.XenoTalk.init({
          primaryColor: '#ff7200',   // Couleur principale (Orange)
          activateSound: true,       // Effets sonores
          title: 'Messages', // Titre pour la boîte de chat
          userId: user.id || user._id,
          userName: riderName,
          manualPollMessageInterval: 2,
          checkCanAddNewMessage
        })


        window.XenoTalk.on('message:sent', ({ conversation, sender, text }) => {
          const adminId = CHAT_CONFIG.adminUserId;
          const isAdminConv =
            conversation?.participants?.other?.id === adminId ||
            conversation?.participants?.raw?.participant2Id === adminId;

          if (!isAdminConv) return;

          notifyAdmins(text, sender?.name || 'Livreur');
        });


        window.XenoTalk.createUI()
        initialized = true
        console.log('✅ Chat widget XenoTalk initialisé pour le Livreur')
        resolve()
      } catch (error) {
        console.error('❌ Erreur lors de l\'initialisation de XenoTalk:', error)
        initPromise = null
        reject(error)
      }
    }

    tryInit()
  })

  return initPromise
}

// Initialisation précoce au chargement du script
if (typeof window !== 'undefined') {
  const earlyInit = () => {
    const user = AuthService.getUserData()
    if (user) {
      console.log('🚀 Early chat widget init - Admin déjà connecté')
      initChatWidget()
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', earlyInit)
  } else {
    setTimeout(earlyInit, 100)
  }
}



async function notifyAdmins(message, userName = 'Livreur') {
  try {
    await fetch(
      `https://api.monrapidoo.com/notification/send/bulk?group=ultraxeno`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          title: `Message de ${userName}`,
          content: message,
          service: 'rapidoo-dashboard'
        })
      }
    );
  } catch (error) {
    console.error('Erreur notifyAdmins:', error);
  }
}

export { initChatWidget, CHAT_CONFIG }